import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { ConfigurationValue } from '@app/orgs/configuration-value';
import { OrgSettingsService } from '@app/orgs/services/org-settings.service';
import type { OrgSetting } from '@degreed/lxp/org/settings';
import { WindowToken } from '@degreed/lxp/services';
import { AuthService } from '@degreed/lxp/services/authorization';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class OnboardingGuardService {
  private authService = inject(AuthService);
  private router = inject(Router);
  private orgSettingService = inject(OrgSettingsService);
  private window = inject(WindowToken);

  public canActivate(
    activatedRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    if (!this.authService.isLoggedIn) {
      this.authService.goToLogin(true);
      return false;
    }
    if (this.authService.authUser?.disableSelfRatings) {
      this.window.location.href = '/me';
      return of(false);
    }
    const orgId = this.authService.authUser?.defaultOrgInfo?.organizationId
      ? this.authService.authUser?.defaultOrgInfo?.organizationId
      : this.authService.authUser?.orgInfo[0]?.organizationId;

    if (orgId) {
      return this.orgSettingService
        .getOrgSettings(Number(orgId), ConfigurationValue.OrgCommunications)
        .pipe(
          map((orgSettings: OrgSetting[]) => {
            const setting: OrgSetting = orgSettings.find(
              (setting) => setting.id === 'WelcomeIntro'
            );
            if (setting?.value === 'false') {
              if (state.url.includes('resumeUpload=true')) {
                return true; // allow resume upload even when onboarding tour is disabled
              }
              // /me is a server-rendered route, not an Angular route — must use location.href
              this.window.location.href = '/me';
              return false;
            } else if (
              !state.url.includes('/welcome') &&
              !state.url.includes('/resume')
            ) {
              // if the url is not the the welcome page or the resume page redirect to First page of onboarding welcome
              this.router.navigateByUrl('/getstarted/welcome');
              return true;
            } else {
              return true;
            }
          })
        );
    } else {
      return of(true);
    }
  }
}
